export default __webpack_public_path__ + "static/media/logo-dark.e450ae77.png";